// Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved

import { css } from 'emotion';
import React from 'react';
import { useSelector } from 'react-redux'
import TodoItem from './TodoItem';
import { createSelector } from 'reselect'


const selectNumOfDoneTodos:any = createSelector(
  (state: any) => state.Todo,
  (Todo: any) => Todo.todos.length
)

 const TodoList = () => { 
  const todoCount:number = useSelector(selectNumOfDoneTodos)
  const lastUpdated:number = useSelector((state:any )=> state.Todo.todos.length)

  return (
    <div>
      <div className={styles.count}>You have {todoCount} todos</div>
      <ul className={styles.todos}>
        {new Array(todoCount).fill(null).map((_, index) => (
          <TodoItem index={index} key={index} />
        ))}
      </ul>
      <div className={styles.lastUpdated}>
        Last updated: {lastUpdated ? new Date(lastUpdated).toString() : 'never'}
      </div>
    </div>
  );
}

const styles = {
  count: css`
    font-size: 12px;
  `,
  lastUpdated: css`
    color: #666;
    font-size: 10px;
  `,
  todos: css`
    padding-left: 0;
  `,
};


export default TodoList